import React, { useState, useEffect } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    NumberInput,
    useNotify,
    useRedirect,
    SelectArrayInput,
    BooleanInput,
    useCreate
} from 'react-admin';

export const ModelSchemaCreate = () => {
    return (
        <Create redirect="list">
            <SimpleForm>
                <TextInput name="name" source="name" validate={[required()]} fullWidth />
                <TextInput name="modelSchema" source="modelSchema" fullWidth validate={[required()]} multiline  rows={24}/>
            </SimpleForm>
        </Create>
    );
}